import { create } from 'zustand';
import { api } from '../lib/api.js';

function safeParseUser() {
  try {
    const raw = localStorage.getItem('user');
    if (!raw || raw === 'undefined') return null;
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === 'object' ? parsed : null;
  } catch (err) {
    console.warn('authStore: localStorage.user corrupto, limpiando sesión', err);
    try { localStorage.removeItem('user'); localStorage.removeItem('token'); } catch {}
    return null;
  }
}

function saveSession(token, user) {
  localStorage.setItem('token', token);
  localStorage.setItem('user', JSON.stringify(user));
}

export const useAuthStore = create((set) => ({
  user:  safeParseUser(),
  token: (() => { try { return localStorage.getItem('token') || null; } catch { return null; } })(),

  login: async (email, password) => {
    const { data } = await api.post('/auth/login', { email, password });
    // Soporta dos formatos de respuesta:
    //  - App staff (/api/auth/login):  { token, userId, name, email, role }
    //  - CRM (/api/crm-auth/login):    { access, refresh, user: { sub, name, email, role, modules } }
    const token = data.token || data.access;
    const src   = data.user || data;
    const user  = {
      id:      data.userId || src.sub || src.id,
      name:    src.name,
      email:   src.email,
      role:    src.role,
      modules: src.modules,
    };
    saveSession(token, user);
    set({ user, token });
    return user;
  },

  clientLogin: async (phone, password) => {
    const { data } = await api.post('/auth/client-login', { phone, password });
    const user = { id: data.userId, name: data.name, email: data.email, role: data.role, phone };
    saveSession(data.token, user);
    set({ user, token: data.token });
    return user;
  },

  registerClient: async (payload) => {
    const { data } = await api.post('/auth/register-client', payload);
    if (data.needsPhoneVerification) return data;
    const user = { id: data.userId, name: data.name, email: data.email, role: data.role };
    saveSession(data.token, user);
    set({ user, token: data.token });
    return user;
  },

  saveSession: (token, user) => {
    saveSession(token, user);
    set({ user, token });
  },

  loginWithToken: (token, user) => {
    saveSession(token, user);
    set({ user, token });
    return user;
  },

  setSession: (token, user) => {
    saveSession(token, user);
    set({ user, token });
    return user;
  },

  logout: async () => {
    try {
      await api.post('/auth/logout');
    } catch {
      // Proceder aunque falle (token ya expirado, etc.)
    }
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    set({ user: null, token: null });
    window.location.href = '/login';
  },
}));
